// reducers/participantsSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';

const LOCAL_STORAGE_KEY = 'currentParticipant';
interface ParticipantsState {
  currentParticipant: any | null;
}
const getStoredParticipant = () => {
  const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
  return stored ? JSON.parse(stored) : null;
};
const initialState: ParticipantsState = {
  currentParticipant: getStoredParticipant(), // Charge depuis le localStorage
};
const participantsSlice = createSlice({
  name: 'participantsLS',
  initialState: initialState,
  reducers: {
    setCurrentParticipant: (state, action: PayloadAction<any>) => {
      state.currentParticipant = action.payload;
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(action.payload));
    },
  },
});

export const ParticipantsLSActions = participantsSlice.actions;
export default participantsSlice.reducer;

const selectParticipantsState = (state: any) => {
  return state.participantsLocalStored;
};

export const selectCurrentParticipant = createSelector(
  selectParticipantsState,
  (participants) => participants.currentParticipant,
);

export const selectCurrentParticipantId = createSelector(
  selectCurrentParticipant,
  (currentParticipant) => currentParticipant?._id,
);

export const selectCurrentParticipantBillableEntity = createSelector(
  selectCurrentParticipant,
  (currentParticipant) => currentParticipant?._billableEntity,
);

export const selectCurrentParticipantDsoDetails = createSelector(
  selectCurrentParticipant,
  (currentParticipant) => currentParticipant?._dsoDetails,
);

export const selectCurrentParticipantOperationId = createSelector(
  selectCurrentParticipant,
  (currentParticipant) => currentParticipant?._operationId,
);
